import { restApiIP } from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApiIP.post("/api/target-inv-simulation/results", params);
};

const getAllForCSV = params => {
  return restApiIP.post("/api/target-inv-simulation/results/csv", params);
};

const remove = ids => {
  return restApiIP.delete(`/api/target-inv-simulation/results${ids}`);
};

const targetInvSimulationResultService = {
  getAll,
  getAllForCSV,
  remove
};

export default targetInvSimulationResultService;